var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.submission != null)?_c('TemplateSubmissionInfo'):_vm._e(),_c('EmailTextAreaCopy',{attrs:{"mail":_vm.mail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }